import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class WorkDay  {
    _originalTypeClassName = "zERP.BO.WorkDay";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
WorkDay.translate = translateService;
}
this.Id = null;
this.IsInsured = false;
this.DayHours = null;
this.Day = null;
this.Week = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsInsured:any;
DayHours:any;
Day:any;
Week:any;
WorkProgramm:any;
static setWorkProgramm = ($this, value) => {
var oldValue = $this.WorkProgramm;
$this.WorkProgramm = value;
if (value != null) {
}
}

static ReturnWeekDay(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? Domain.WeekDay.Monday : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? Domain.WeekDay.Tuesday : ((CLMS.Framework.Number.Equal(() => index, () => 2) ? Domain.WeekDay.Wendesday : ((CLMS.Framework.Number.Equal(() => index, () => 3) ? Domain.WeekDay.Thursday : ((CLMS.Framework.Number.Equal(() => index, () => 4) ? Domain.WeekDay.Friday : ((CLMS.Framework.Number.Equal(() => index, () => 5) ? Domain.WeekDay.Saturday : Domain.WeekDay.Sunday)))))))))));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}